import { Search } from 'lucide-react';
import { baseFieldClass, borderClassFor } from './inputStyles';

export interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  error?: boolean;
  disabled?: boolean;
  id?: string;
  name?: string;
}

// Search box with a magnifying-glass icon, reused across list and filter UIs.
export const SearchInput = ({
  value,
  onChange,
  placeholder = 'Search',
  className = 'w-52',
  error = false,
  disabled = false,
  id,
  name,
}: SearchInputProps) => (
  <div className={`relative ${className}`}>
    <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 opacity-60" />
    <input
      id={id}
      name={name}
      disabled={disabled}
      className={`${baseFieldClass(error)} h-9 pl-9 pr-3 ${borderClassFor(error)} ${disabled ? 'bg-gray-50 cursor-not-allowed' : ''}`}
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  </div>
);
